export class FinalDataFullModel {
  solicitation_completed: boolean;
}
